<template>
  <div v-if="!isLoaded">
    <IsLoadingComponent />
  </div>
  <div v-else-if="!hasAccess" class="main-container">
    <div class="info-section">
      <v-icon color="red">mdi-alert-circle-outline</v-icon>
      <div class="info">
        {{ accessMessage }}
      </div>
    </div>
  </div>
  <div v-else id="boxcontainer" :class="{ disableStyle: !isValid }"></div>
</template>
<script>
import { mapActions } from 'vuex'
import { getBoxToken } from '@/service/engagement.js'
import { getWorkfileId } from '@/utils/globalUtil'
import { formatTimestamps } from '@/utils/dateUtils'
import IsLoadingComponent from './IsLoadingComponent.vue'

export default {
  name: 'BoxComponent',
  components: {
    IsLoadingComponent
  },
  props: {
    assignmentData: {
      type: Object,
    },
    allowedExtensions: {
      type: Array,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    subFolder: {
      type: String,
    },
    copyBoxFileToAccounting: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      boxObject: [],
      showBoxContainer: false,
      formattedLocalTime: null,
      attributeTime: null,
      isLoaded: false,
      hasAccess: false,
      accessMessage: null,
    }
  },
  methods: {
    ...mapActions({
      add: "notification/add",
    }),
    setTimestamps(date = new Date()) {
      const { attributeTime, formattedLocalTime } = formatTimestamps(date)
      this.attributeTime = attributeTime
      this.formattedLocalTime = formattedLocalTime
    },
    async iterateItems(items, that) {
      const rv = await this.copyToAccounting(items)
      rv.forEach((item) => {
        let obj = {
          id: item.id,
          name: item.name,
          size: item.size,
          folderId: item.parent?.id || 0,
          created_at: item.created_at,
          modified_by: item.modified_by?.login || 'System',
        }
        that.boxObject.push(obj)
      })
      that.$emit('boxObject', that.boxObject)
    },
    async copyToAccounting(files) {
      console.log(files)
      if (!this.copyBoxFileToAccounting) {
        return files
      }
      let workfile = this.assignmentData?.workFileLink
      let folderId = getWorkfileId(workfile)
      let boxTokenObject = await getBoxToken(folderId)
      let boxToken = boxTokenObject ? boxTokenObject.token : null
      let returnList = []
      for (const file of files) {
        try {
          // Added timestamp for file name before . ext
          const fileExtension = file.name.split('.').pop()
          const fileNameWithoutExt = file.name.substring(
            0,
            file.name.lastIndexOf('.')
          )

          this.setTimestamps()
          const newFileName = `${fileNameWithoutExt}_${this.formattedLocalTime}.${fileExtension}`

          // For simplicity, we'll just use the original file as copying is not implemented in outlook addin
          returnList.push(file)
        } catch (error) {
          this.add({
            type: 'error',
            message: `File ${file.name} already present in destination folder.`,
          })
          returnList.push(file)
        }
      }
      return returnList
    },
    async openBox() {
      let workfile = this.assignmentData?.workFileLink
      let folderId = getWorkfileId(workfile)
      let boxTokenObject = await getBoxToken(folderId)
      this.isLoaded = true

      if (boxTokenObject == null || !boxTokenObject.hasUserAccount) {
        this.showBoxContainer = false
        let notification = {
          type: 'error',
          message: 'You do not have access to Box.',
        }
        // this.add(notification)
        this.hasAccess = false
        this.accessMessage = notification.message
      } else if (!boxTokenObject.hasFolderAccess) {
        this.showBoxContainer = false
        let notification = {
          type: 'error',
          message: 'You do not have access to this Box folder.',
        }
        // this.add(notification)
        this.hasAccess = false
        this.accessMessage = notification.message
      } else {
        this.hasAccess = true
        this.accessMessage = null
        this.showBoxContainer = true
        const that = this
        let boxToken = boxTokenObject.token
        let boxFolderId = boxTokenObject.folderId
        let filePicker = new Box.FilePicker()
        this.$nextTick(() => {
          filePicker.show(boxFolderId, boxToken, {
            container: '#boxcontainer',
            logoUrl: 'box',
            extensions: [],
            canSetShareAccess: false,
            canUpload: true,
            chooseButtonLabel: 'Add',
          })
        })
        filePicker.addListener('choose', function (items) {
          that.iterateItems(items, that)
        })
        filePicker.addListener('cancel', function () {
          filePicker.clearCache()
          that.$emit('closeModal')
        })
      }
    },
  },
  mounted() {
    this.openBox()
  },
}
</script>
<style scoped>
.info-section {
  display: flex;
    align-items: center;
    background-color: #ffe7e7;
    padding: 24px;
    margin-left: 12px;
    margin-right: 12px;
    border-radius: 4px;
    margin-bottom: 4px;
    border: 1px solid #b92424a6;
}


.info-section .info {
  margin-left: 8px;
  font-size: 14px;
}

.disableStyle {
  pointer-events: none;
  opacity: 0.6;
}
</style>